// extracted by mini-css-extract-plugin
module.exports = {"reviewInCart":"az__db"};